var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { createContext, useContext, useReducer } from "react";
export var RequiredAction;
(function (RequiredAction) {
  RequiredAction["REJECTED"] = "REJECTED";
  RequiredAction["GIVE_PEER_REVIEW"] = "GIVE_PEER_REVIEW";
  RequiredAction["PENDING_PEER_REVIEW"] = "PENDING_PEER_REVIEW";
})(RequiredAction || (RequiredAction = {}));
export var courseProgressReducer = function courseProgressReducer(state, action) {
  switch (action.type) {
    case "SET_LOADING":
      return __assign(__assign({}, state), {
        loading: action.payload
      });
    case "SET_COURSE_PROGRESS":
      return __assign(__assign({}, state), {
        courseProgressData: __assign({}, action.payload)
      });
    case "SET_ERROR":
      return __assign(__assign({}, state), {
        error: action.payload
      });
    case "SET_ALL":
      return __assign(__assign({}, state), {
        loading: action.payload.loading,
        error: action.payload.error,
        courseProgressData: action.payload.courseProgressData
      });
    default:
      throw new Error("Unhandled action type.}");
  }
};
var CourseProgressContext = createContext(undefined);
export var setLoading = function setLoading(value) {
  return {
    type: "SET_LOADING",
    payload: value
  };
};
export var setAll = function setAll(value) {
  return {
    type: "SET_ALL",
    payload: value
  };
};
export var CourseProgressProvider = function CourseProgressProvider(_a) {
  var children = _a.children,
    courseProgress = _a.courseProgress;
  var _b = useReducer(courseProgressReducer, courseProgress),
    _ = _b[0],
    dispatch = _b[1];
  return React.createElement(CourseProgressContext.Provider, {
    value: {
      state: courseProgress,
      dispatch: dispatch
    }
  }, children);
};
export var useCourseProgressState = function useCourseProgressState() {
  var context = useContext(CourseProgressContext);
  if (context === undefined) {
    throw new Error("useCourserProgressState must be used within a CourseProgressProvider");
  }
  return context;
};